export default __webpack_public_path__ + "static/media/dev_3.a75fdfc7.png";